import { createReducer } from '@reduxjs/toolkit';
import { setNewsletterInterests, setNewsletterIsLoading, setNewsletterEmail } from './actions';
const initialState = {
    interests: {
        ymeInterests: [],
        racingInterests: [],
    },
    email: '',
    isLoading: false,
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setNewsletterInterests, (state, action) => ({
        ...state,
        interests: action.payload,
    }))
        .addCase(setNewsletterIsLoading, (state, action) => ({
        ...state,
        isLoading: action.payload,
    }))
        .addCase(setNewsletterEmail, (state, action) => ({
        ...state,
        email: action.payload,
    }));
});
